/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalPlugin from 'react-modal';

import useModal from '../../hooks/useModal';
import { ToggleBtn } from './styles';
import { ReactComponent as PlusIcon } from '../../assets/svg/plus-circle.svg';

ModalPlugin.setAppElement('#root');

const Modal = ({ content }) => {
  const { modal, closeModal } = useModal();
  const navigate = useNavigate();
  const modalContainer = useRef();

  const handleClose = () => {
    const lastUrl = localStorage.getItem('last');
    if (lastUrl) {
      navigate(lastUrl);
    } else {
      navigate('/');
    }
    closeModal();
  };

  const outsideClickListener = (event) => {
    if (
      modalContainer.current &&
      modalContainer.current !== event.target &&
      !modalContainer.current.contains(event.target)
    ) {
      handleClose();
    }
  };

  const keyUpListener = (event) => {
    if (event.code === 'Escape') {
      handleClose();
    }
  };

  const afterOpen = () => {
    document.addEventListener('keyup', keyUpListener);
    document.addEventListener('click', outsideClickListener);
  };

  const afterClose = () => {
    document.removeEventListener('click', outsideClickListener);
    document.removeEventListener('keyup', keyUpListener);
  };

  return (modal && modal.show) || !!content ? (
    <ModalPlugin
      isOpen={modal.show || !!content}
      onAfterOpen={afterOpen}
      onAfterClose={afterClose}
      onRequestClose={closeModal}
      style={{
        overlay: { zIndex: 10, backgroundColor: 'rgba(0, 0, 0, 0.25)' },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: '0px 7px 22px 22px',
          // height: '90vh',
          maxHeight: '90vh',
          maxWidth: '98vw',
          overflow: 'hidden',
        },
      }}
      contentLabel="Modal"
    >
      <div
        ref={modalContainer}
        style={{
          flex: 1,
          maxHeight: 'calc(90vh - 44px)',
          paddingTop: '22px',
          paddingRight: '15px',
          overflow: 'auto',
        }}
      >
        <ToggleBtn
          style={{ paddingRight: '5px' }}
          className="close-modal"
          onClick={handleClose}
        >
          <PlusIcon />
        </ToggleBtn>

        {modal.title && <h1>Título: {modal.title}</h1>}
        {modal.content || content}
      </div>
    </ModalPlugin>
  ) : (
    <></>
  );
};

export default Modal;
